import { gql } from '@apollo/client';

export const CLIENT_DISPATCH_SETTINGS_FIELDS = gql`
    fragment ClientDispatchSettingsFields on client_dispatch_settings {
        dispatch_settings_id
        client_id
        partner_client_id
        preferences_delivery_timeframe
        preferences_timeframe_buffer
        preferences_delivery_window_floor
        preferences_delivery_window_ceiling
        preferences_timeframe_round
        preferences_timeframe_round_minute
        preferences_timeframe_buffer_apply
        preferences_service_time
        preferences_service_time_curbside
        preferences_service_time_room_of_choice
        preferences_service_time_incr
        preferences_service_time_first_dry_space
        preferences_service_time_white_glove
        preferences_use_service_default_as_minimum
        preferences_default_start_time
        preferences_require_staging_verification
        created_at
        updated_at
    }
`;
